<template>
  <div class="orderList">
    <el-card shadow="always">
      <el-form
        ref="filterEl"
        size="small"
        label-width="88px"
        :model="filter"
        inline
      >
        <el-form-item v-if="checkAdmin()" prop="companyId" label="所属租户">
          <el-select style="width: 200px" v-model="filter.companyId" placeholder="请选择">
            <el-option label="全部" value="-1"></el-option>
            <el-option
              v-for="item in companyData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="queryDate" label="申请时间">
          <my-datePicker
            width="200px"
            :scopeDate="filter.queryDate"
            @receiveMyDate="queryTimeMyDate"
          />
        </el-form-item>
        <el-form-item prop="" label="审核状态">
          <el-select
            style="width: 200px"
            v-model="filter.auditStatus"
            placeholder="请选择"
          >
            <el-option label="全部" value="-1"></el-option>
            <el-option label="审核通过" :value="2"></el-option>
            <el-option label="不需要审核" :value="9"></el-option>
            <el-option label="教务审核中" :value="30"></el-option>
            <el-option label="教务审核驳回" :value="40"></el-option>
            <el-option label="财务审核中" :value="50"></el-option>
            <el-option label="财务审核驳回" :value="60"></el-option>
            <el-option label="项目负责人审核中" :value="70"></el-option>
            <el-option label="项目负责人审核驳回" :value="80"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="name" label="学员姓名">
          <el-input v-model="filter.name" placeholder="请输入学员姓名" style="width: 200px" clearable />
        </el-form-item>
        <el-form-item prop="phone" label="学员手机号">
          <el-input v-model.trim="filter.phone" placeholder="请输入学员手机号" style="width: 200px" clearable />
        </el-form-item>
        <el-form-item prop="idCard" label="证件号码">
          <el-input v-model.trim="filter.idCard" placeholder="请输入证件号码" style="width: 200px" clearable />
        </el-form-item>
        <el-form-item prop="projectName" label="项目名称">
          <el-input v-model.trim="filter.projectName" placeholder="请输入项目名称" style="width: 200px" clearable />
        </el-form-item>
        <el-form-item style="margin-left: 50px">
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset" style="margin-left: 8px">重置</el-button>
          <el-button v-if="$hasAuthority('app1_internalOrder_export')" @click="handleExport" style="margin-left: 8px">导出</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px" shadow="always">
      <el-row v-if="!checkAdmin()" type="flex" align="middle">
        <el-button type="primary" size="small" @click="handleAddOrder">新建内训订单</el-button>&emsp;
        <el-button type="primary" :disabled="multipleSelection.length === 0" size="small" @click="handleMutipleBill">批量发起验收单</el-button>&emsp;
        <span v-if="multipleSelection.length">已选: {{ multipleSelection.length }}单</span>
      </el-row>
      <el-table
        v-loading="loading"
        ref="multipleTable"
        :data="data"
        border
        style="width:100%;margin-top:10px"
        :row-key="getRowKeys"
        @selection-change="handleSelectionChange"
      >
        <el-table-column v-if="!checkAdmin()" type="selection" :reserve-selection="true" :selectable="checkSelectable" width="55" align="center" />
        <el-table-column label="所属租户" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.companyName || "--" }}</span>
          </template>
        </el-table-column>

        <el-table-column label="学员姓名" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.name || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="学员手机号" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.phone || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="证件类型" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.type === 1">身份证</span>
            <span v-else-if="row.type === 2">港澳台身份证</span>
            <span v-else-if="row.type === 3">港澳台通行证</span>
            <span v-else> -- </span>
          </template>
        </el-table-column>
        <el-table-column label="证件号码" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.idCard || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="项目名称" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.projectName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.auditStatus === 2" type="success">审核通过</el-tag>
            <el-tag v-else-if="row.auditStatus === 9" type="warning">不需要审核</el-tag>
            <el-tag v-else-if="row.auditStatus === 30" type="warning">教务审核中</el-tag>
            <el-tag v-else-if="row.auditStatus === 40" type="danger">教务审核驳回</el-tag>
            <el-tag v-else-if="row.auditStatus === 50" type="warning">财务审核中</el-tag>
            <el-tag v-else-if="row.auditStatus === 60" type="danger">财务审核驳回</el-tag>
            <el-tag v-else-if="row.auditStatus === 70" type="warning">项目负责人审核中</el-tag>
            <el-tag v-else-if="row.auditStatus === 80" type="danger">项目负责人审核驳回</el-tag>
            <span v-else> -- </span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.insertDate || "--" }}</span>
          </template>
        </el-table-column>

        <el-table-column width="226" fixed="right" label="操作" align="center">
          <template slot-scope="{ row }">
            <span class="blue_Box" @click="openOrderDetail(row.orderId)">订单详情</span>
            <span class="blue_Box" v-if="[40,60,80].includes(row.auditStatus)" @click="openUploadCertificate(row)">重新上传支付凭证</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </el-card>
    <!-- 导出 -->
    <FileExport ref="FileExport" />
    <!-- 订单详情 -->
    <OrderDetail ref="orderDetailRef" />
    <!-- 上传凭证 -->
    <UploadCertificate ref="uploadCertificateRef" />
  </div>
</template>

<script>
import { getInternalOrderListPage, getSelectCompanyList, addInternalBill } from '@/api/orderAdmin/orderList'
import { getAppUserInfo } from '@/api/common'
import myDatePicker from "@/components/myDatePicker.vue";
import OrderDetail from "@/views/orderAdmin/components/orderDetail.vue";
import UploadCertificate from "@/views/orderAdmin/components/uploadCertificate.vue";
import myPagination from '@/components/myPagination.vue'
import FileExport from "@/components/FileExport.vue";
import { clone, processing } from "@/utils/handle.js";

export default {
  name: 'internalOrderList',
  components: {
    myDatePicker,
    OrderDetail,
    UploadCertificate,
    myPagination,
    FileExport
  },
  data () {
    return {
      loading: false,
      companyData: [],
      filter: {
        companyId: '-1',
        queryDate: [],
        queryDateStart: '',
        auditStatus: '-1',
        name: '',
        phone: '',
        idCard: '',
        projectName: ''
      },
      data: [],
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0
      },
      searchData: {},
      multipleSelection: []
    }
  },
  mounted () {
    this.getSelectCompanyList();
  },
  methods: {
    // 刷新
    refresh () {
      this.getOrderListPage(
        Object.assign(clone(this.searchData), {
          page: this.pageInfo.page,
          limit: this.pageInfo.limit
        })
      )
    },
    handleExport () {
      const params = { ...this.searchData }
      delete params.queryDate
      this.$refs.FileExport.init(
        params, // 搜索表单参数
        "jsw-order-provider", // 后端对应业务线服务
        "/order/adm/order/downInternalOrder", // 导出-对应的接口
        1, //  状态：0get、1post
        "内训报名订单.xlsx" //文件名称
      );
    },
    // 新建内训订单
    handleAddOrder () {
      window.history.pushState(null,'', '/analyse/serviceWorkbench/addInternalTrainOrder')
    },
    // 批量发起验收单
    handleMutipleBill () {
      this.$confirm(`是否确认批量发起验收单?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const orderIds = this.multipleSelection.map(({ orderId }) => orderId).join(',')
        const params = { orderIds }
        addInternalBill(params).then(({ code }) => {
          if (code === 0) {
            this.$message.success('批量发起验收成功!')
            this.$refs.multipleTable.clearSelection()
          }
        })
      })
    },
    // 订单详情
    openOrderDetail (id) {
      this.$refs.orderDetailRef.init(id)
    },
    // 重新上传凭证
    openUploadCertificate(payload) {
      this.$refs.uploadCertificateRef.init({
        payload,
        id: payload.orderId
      });
    },
    // 列表请求
    async getOrderListPage (payload) {
      this.loading = true
      this.pageInfo.page = payload.page
      this.pageInfo.limit = payload.limit
      delete payload.queryDate
      const res = await getInternalOrderListPage({ ...payload });
      this.data = res.data?.records || [];
      this.pageInfo.total = Number(res.data?.total) || 0;
      this.loading = false
    },
    // 列表选择
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    getRowKeys (row) {
      return row.orderId
    },
    checkSelectable (row) {
      return row.auditStatus === 2 && row.checkStatus === 1
    },
    // 支付时间
    queryTimeMyDate (payload) {
      this.filter.queryDate = payload
      this.filter.queryDateStart = payload[0] + ' 00:00:00'
      this.filter.queryDateEnd = payload[1] + ' 23:59:59'
    },
    // 搜索
    handleSearch () {
      this.searchData = processing(this.filter)
      this.getOrderListPage(
        Object.assign(processing(this.filter), { page: 1, limit: 10 })
      )
    },
    // 重置
    handleReset () {
      this.searchData = {}
      this.filter.queryDate = []
      this.filter.queryDateStart = ''
      this.filter.queryDateEnd = ''
      this.$refs['filterEl'].resetFields()
      this.$refs.multipleTable.clearSelection()
      this.getSelectCompanyList()
    },
    // 切换页数
    handleCurrentChange (payload) {
      this.getOrderListPage(
        Object.assign(clone(this.searchData), {
          page: payload,
          limit: this.pageInfo.limit
        })
      )
    },
    // 切换每页条数
    handleSizeChange (payload) {
      this.getOrderListPage(
        Object.assign(clone(this.searchData), { page: 1, limit: payload })
      )
    },
    // 租户列表
    getSelectCompanyList() {
      getSelectCompanyList().then((res) => {
        if (res.code === 0) {
          this.companyData = res.data || [];
          this.filter.companyId = res.data[0]?.id;
          this.searchData.companyId = res.data[0]?.id;
          this.getOrderListPage({
            page: 1,
            limit: 10,
            companyId: this.filter.companyId,
          });
        }
      });
    },
    handleViewPhone (row, index) {
      if (!/\*/.test(row.phone)) {
        return
      }
      getAppUserInfo({ userId: row.userId }).then(({ code, data: { phone } }) => {
        if (code === 0) {
          this.data.forEach((item, i) => {
            if (i === index) {
              item.phone = phone
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.orderList {
  .blue_Box {
    white-space: nowrap;
    margin: 0 6px;
    color: #2d8cf0;
    cursor: pointer;
  }

  .blue_Box:hover {
    color: #57a3f4;
  }
}
</style>
